import Container from '@/components/container/Container';
import type { ReactNode } from 'react';
import styles from '../onboarding.module.css';

type Props = {
	children: ReactNode;
};

const AccordionContentLayout = ({ children }: Props) => {
	return (
		<Container className={styles.onboardingContentContainer}>
			{children}
		</Container>
	);
};

export default AccordionContentLayout;
